module.exports = __webpack_public_path__ + "img/location.8f9ce0b5.svg";